import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.less'],
})
export class TooltipComponent implements OnInit {
  tooltip: string = '';
  left: number = 0;
  top: number = 0;
  position: 'top' | 'bottom' = 'bottom';

  constructor() {}

  ngOnInit(): void {}
}
